import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import useToast from 'hooks/useToast';

interface UseUnassignUserProps {
    orgId: string;
    dealId: number;
    timelineId: number;
}

const unassignUserFromTimeline = async (
    orgId: string,
    dealId: number,
    timelineId: number,
    userCorrelationId: string,
): Promise<void> => {
    await axiosInstance.delete(
        API_ENDPOINTS.TIMELINE_ASSIGNEE_BY_USER(orgId, dealId, timelineId, userCorrelationId),
    );
};

export const useUnassignUser = ({ orgId, dealId, timelineId }: UseUnassignUserProps) => {
    const queryClient = useQueryClient();
    const { showSuccess, showError } = useToast();

    return useMutation({
        mutationFn: (userCorrelationId: string) =>
            unassignUserFromTimeline(orgId, dealId, timelineId, userCorrelationId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['timelines', orgId, dealId] });
            queryClient.invalidateQueries({ queryKey: ['timeline-assignees', timelineId] });
            showSuccess('User removed successfully');
        },
        onError: () => {
            showError('Failed to remove user');
        },
    });
};
